var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.localized)?_c(_vm.component,_vm._b({tag:"component"},'component',_vm.$props,false)):_c('div',{staticClass:"d-flex col cards"},_vm._l((3),function(n){return _c('div',{key:n.id,staticClass:"card mr-2 text-center"},[_vm._v(" "+_vm._s(n)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }